import { useMutation } from '@tanstack/react-query';
import type { AgentApiProfitsShow } from '@/types/serializers';

type Params = { id: number; entry_confirmed_date: string; payment_date: string };

export default function useConfirmEntry() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ id, entry_confirmed_date, payment_date }: Params) => {
      const res = await fetch(`/agent/api/profits/${id}/confirm_entry`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ entry_confirmed_date, payment_date }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.errors?.join(', ') || '入社確定に失敗しました');
      }
      const data: AgentApiProfitsShow = await res.json();
      return data;
    },
  });
}
